import React from 'react'
import ComponentHome1 from './components/componentHome1'
import ComponentHome2 from './components/componentHome2'
import ComponentHome3 from './components/componentHome3'
import ComponentHome4 from './components/componentHome4'
import ComponentHome5 from './components/componentHome5'
import ComponentHome6 from './components/componentHome6'
import Header from '../../components/Header'
import Card1 from './components/Card1'
import Card2 from './components/Card2'
import CardValidarGov from './components/CardValidarGov'
import Card3 from './components/Card3'
import Card4 from './components/Card4'
import BenefitsGrid from './components/BenefitsGrid'
import Card5 from './components/Card5'
import FooterHome from './components/FooterHome'

export default function Home2() {
  return (
    <div>
        <Header />
        <Card1 />
        <Card2 />
        <CardValidarGov />
        <Card3 />
        <BenefitsGrid />
        <Card4 /> 
        {/* <Card5 /> */}
        <FooterHome />
        {/* <ComponentHome5 /> */}
        {/* <ComponentHome6 />  */}
        {/* <ComponentHome1 />
        <ComponentHome2 />
        <ComponentHome3 />
        <ComponentHome4 />

         */}
    </div>
  )
}
